import React from "react";
import Header from "./Header";
import { Box, Typography } from "@mui/material";
import image from "../assets/invite-image.png";
// import wa from "../assets/whatsapp.png";
import share from "../assets/share.png";
// import gmail from "../assets/gmail.png";
import { Share } from '@capacitor/share';

const Invite = () => {
  async function handleShare(e) {
    e.preventDefault();
    const shareData = {
      title: "Share Cognecho",
      text: "Know more about this app",
      url: "https://cognisights.vtpwowmansions.com/",
    };
    if (navigator.share) {
      try {
        await navigator.share(shareData);
        console.log("Content shared via Web Share API!");
      } catch (error) {
        console.error("Error using Web Share API:", error);
      }
    } else {
      try {
        await Share.share(shareData);
        console.log("Content shared via Capacitor Share API!");
      } catch (error) {
        console.error("Error using Capacitor Share API:", error);
      }
    }
  }
  return (
    <Box className="parent-div">
      <Header />
      <Box
        sx={{ display: "flex", flexDirection: "column", flex: 1, justifyContent: 'center'}}
        className="main-container"
      >
        <Typography variant="p" sx={{fontSize: '18px', color: '#000', mb: 5, textAlign: 'center'}}>"Invite & Connect!"<br/>
        Share the app with your friends and enjoy a better experience together.</Typography>
        <img src={image} alt="Invite" />
        <Box sx={{display: 'flex', justifyContent: 'center'}} mt={5}>

        {/* <Box className="box-option" sx={{borderRadius: '14px', padding: '20px'}}>
          <a href="">
            <img src={gmail} alt="Gmail" width={50} />
          </a>
        </Box>
        <Box className="box-option" sx={{borderRadius: '14px', padding: '20px'}}>
          <a href="">
            <img src={wa} alt="Whatsapp" width={50} />
          </a>
        </Box> */}
        <Box className="box-option" sx={{borderRadius: '14px', padding: '20px'}} >
          <a onClick={handleShare}>
            <img src={share} alt="Share" width={50} />
          </a>
        </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Invite;
